<fin-loyalty-view [pageTitle]="pageTitle$ | async">
  <ng-container *ngIf="{ val: isEligible$ | async } as isEligible">
    <div class="mr-xlarge-b">
      <h2 class="custom-decorated-heading nordic-blue-900-text font-heading-2 mr-small-b pr-large-t">
        {{ 'tierProgress.tierProgress' | finLocalization }}
      </h2>
      <fin-tier-progress />
    </div>
    <div class="mr-xlarge-b">
      <h2 class="custom-decorated-heading nordic-blue-900-text font-heading-2 mr-xlarge-b pr-large-t">
        {{ 'tierBenefits.tierBenefits' | finLocalization }}
      </h2>
      <fin-upgrade-benefits></fin-upgrade-benefits>
    </div>
  </ng-container>
</fin-loyalty-view>

<fin-cms-json-content
  class="grid-col-12 grid-max-width no-row-gap mr-large-b"
  [template$]="template$"
  [showSideTitle$]="showSideTitle$"
  [pageViewType$]="pageViewType$"
></fin-cms-json-content>

<div *ngIf="(isEligible$ | async) === false" class="grid-col-12 grid-max-width no-row-gap">
  <div class="col-1-12 md-col-5-12 mr-xlarge-b">
    <h3 class="nordic-blue-900-text mr-small-b">
      {{ 'LOYALTY.tierBenefits.nonEligibleInfo.heading' | finLocalization }}
    </h3>
    <p>{{ 'LOYALTY.tierBenefits.nonEligibleInfo.description.0' | finLocalization }}</p>
    <p>{{ 'LOYALTY.tierBenefits.nonEligibleInfo.description.1' | finLocalization }}</p>
  </div>
</div>
